<template>
    <div class="clientes">

        <b-spinner variant="primary" v-if="!showForm" class="dvLoading"
                   type="grow" label="Spinning"></b-spinner>

        <div class="dvTitle">
            <h5 class="title">Clientes</h5>
            <div class="dvBoton" @click="addCliente">
                Agregar
            </div>
        </div>

        <div class="dvAccion">
            <Search v-model="search" />
        </div>

        <div class="dvTable" ref="content" v-if="showForm">
            <b-table striped hover
                     sticky-header
                     head-variant="dark"
                     :items="items"
                     :fields="fields"
                     :filter="search"
                     :filterIncludedFields="filterOn"
                     responsive
                     id="table-transition"
                     @row-selected="onRowSelected"
            >
                <template v-slot:cell(accion)="row">
                    <i class="far fa-edit hover cursor" style="width: 20px" @click="onRowSelected(row)"></i>
                </template>
            </b-table>
        </div>

    </div>
</template>

<script>
    import Search from "../../components/comun/Search";
    import {mapActions, mapState, mapMutations} from 'vuex';

    export default {
        name: "Cliente",

        data() {
            return {
                search: '',
                filterOn:['tax_id', 'legal_name', 'email'],
                fields: [
                    {
                        key: 'tax_id',
                        sortable: true,
                        label: 'RFC',
                        headerTitle: 'RFC'
                    },
                    {
                        key: 'legal_name',
                        label: 'Razón Social',
                        sortable: true,
                    },
                    {
                        key: 'email',
                        sortable: true,
                        label: 'Email',
                    },
                    {
                        key: 'accion',
                        label: '',
                        sortable: false
                    },
                ],
                showForm: false,
                items: []
            }
        },
        components: {Search},

        mounted: function () {
            window.addEventListener("resize", this.resize);
            setTimeout(() => {
                this.resize();
            }, 300);
            this.getCliente().then( data => {
                if (data.current && data.current.data) {
                    this.items = data.current.data;
                }
                this.showForm = true;
            })
        },

        methods: {

            ...mapActions([
                'getCliente'
            ]),

            ...mapMutations([
                'SET_MENU',
            ]),

            onRowSelected: function (row) {
                this.$router.push('/Clientes/Edit/' + row.item.id);
            },

            resize: function () {
                if (window.innerWidth <= 992) {
                    this.SET_MENU(false);
                }

                let winHeight = window.innerHeight - 136;
                if (this.$refs.content !== undefined && this.$refs.content.children[0] !== undefined) {
                    if (winHeight < 220) {
                        this.$refs.content.children[0].style.maxHeight = '220px';
                    } else {
                        this.$refs.content.children[0].style.maxHeight = winHeight + 'px';
                    }
                }
            },

            addCliente: function () {
                this.$router.push('/Clientes/Add');
            }

        }
    }
</script>

<style scoped lang="scss">

    @import "../../style/base";

    .clientes {
        padding: 30px;
        border: 1px solid #e6ebf4;
        border-radius: .25rem;
        background-color: #fff;
        margin: 20px;

        animation-name: fade;
        animation-duration: 1.5s;
        animation-timing-function: ease-in-out;

        & .dvBoton {
            @include buttonPrimary(120px, .625rem 1.5rem, $sekaiAzul, $white, $sekaiAzulHover, $sekaiAzulActive);
        }

        & .dvTitle {
            @include flexRow;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 20px;
        }

        & .dvAccion {
            @include flexRow;
            justify-content: flex-end;
            padding-bottom: 20px;

            & .input-group {
                max-width: 240px;
            }
        }

        & .dvTable {
            & .b-table-sticky-header.table-responsive {
                max-height: initial;
            }
        }
    }

</style>